// https://www.algolia.com/doc/api-reference/api-parameters/query/#formatting-rules
export const ALGOLIA_QUERY_MAX_LENGTH = 512
